import React from 'react'

export default function JumbotronComponent() {
    return (
        <div>
            <div class="jumbotron jumbotron-fluid">
                <div class="container">
                    <h1 class="display-4">Forcast</h1>
                    <p class="lead">Progressive Web Application Build on React.</p>
                </div>
            </div>
        </div>
    )
}
